import axios from '../index'

export default {
    getInstitutosDefault (params = {}) {
        return axios.get('/api/v1/instituciones/directiva', {
            params
        })
    },
    getCicloDefault (params = {}) {
        return axios.get('/api/v1/ciclos-escolares/directiva',{
            params
        })
    },
    getPrograma(params) {
        return axios.get('/api/v1/programas/directiva', {
            params
        })
    },
    getCargosNoObligatorios (params) {
        return axios.get( '/api/v1/personas/servicios', {params})
    },
    getInfoPersona (params) {
        return axios.get('/api/v1/personas/info' , {
            params
        })
    },
    getPermisosSeccion (params) {
        return axios.get('/api/v1/personas/permisos', {
            params
        })
    },
    getNivel(params) {
        return axios.get('/api/v1/niveles-academicos/directiva', {
            params
        })
    },
    getNivelInstitucion(institucion) {
        return axios.get('/niveles-academicos/institucion/' + institucion)
    },
    getGenerarCargos (formData) {
        return axios.post('/api/v1/cobranza/acciones/generar-cargos', formData)
    },
    getRestablecerCargos(formData) {
        return axios.post('/api/v1/cobranza/acciones/borrar-cargos', formData)
    },
    postReestablecerSaldos(formData) {
        return axios.post('/api/v1/cobranza/acciones/restablecer-saldos', formData)
    },
    postAplicarBecas(formData) {
        return axios.post('/api/v1/cobranza/acciones/generar-becas', formData)
    },
    postDesaplicarBecas(formData) {
        return axios.post('/api/v1/cobranza/acciones/desaplicar-becas', formData)
    },
    postDesaplicarParcialidad(formData){
        return axios.post('/api/v1/cobranza/acciones/revertir-parcialidades', formData)
    },
    postAplicarPagos(formData) {
        return axios.post('/api/v1/cobranza/acciones/aplicar-pagos', formData)
    },
    postReestablecerSaldos(formData) {
        return axios.post('/api/v1/cobranza/acciones/restablecer-saldos', formData)
    },
    //ciclos-escolares/ciclosPorInstitucion/' + form.institucion_id
    getMetodosPagos (params = {}) {
        return axios.get('/api/v1/cobranza/listado/metodos-pagos-cfdi', {
            params
        })
    },
    getDescuentos (params = {}) {
        return axios.get('/api/v1/cobranza/listado/descuentos', {
            params
        })
    },
    registrarPago (params) {
        return axios.post('/api/v1/personas/registrar-pago',
         params
        )
    },
    registrarPagoAnticipo (params) {
        return axios.post('/api/v1/cobranza/intencion-de-pagos/general/generar',
         params
        )
    },
    getConceptos(params) {
        return axios.get('/api/v1/cobranza/listado/conceptos', {
            params
         })
    },
    getConceptosRegistrarPago(params){
        return axios.get('/api/v1/cobranza/listado/conceptos', {params})
    },
    
    getGetDescuentoConceptos (params) {
        return axios.get( '/api/v1/personas/registrar-descuento', {params})
    },
    getGetDescuento (params) {
        return axios.post( '/api/v1/personas/registrar-descuento', params)
    },
    postSelectPagos (typeCategory, formData) {
        return axios.post('/api/v1/cobranza/cancelaciones/pago', formData)
    },
    postParcializar (params) {
        return axios.post('/api/v1/cobranza/parcializacion-libre', 
           params
        )
    },
    getSelectCargos (formData) {
        return axios.post('/api/v1/cobranza/cancelaciones/cargo', formData)
    },
    getDevolucion(formData){
        return axios.post('/api/v1/cobranza/devoluciones/pago', formData)
    },
    
    // HISTORIAL 
    getHistorial(params){
        return axios.get('/api/v1/cobranza/registro-de-actividad', {params})
    },
    getLogMovimientos(params){
        return axios.get('/logs/getLogFinanzasPorPersona', {params})
    },
    postSantanderMovimientos(formData){
        return axios.post('/webpay/getReferenciaPorPersona', formData)
    },

    // BALANCE 
    
    getBalance(params){
        return axios.get('/cobranza-v2/balanceGeneral', {params})
    },
    postEditarFecha(formData){
        return axios.post('/cobranza-v2/updateMovimiento', formData)
    },
    postMultiplesAcciones(params){
        return axios.get('/cobranza-v2/deleteMovimiento', {params})
    },
    postCambiarConcepto(formData){
        return axios.post('/cobranza-v2/updateConcepto', formData)
    },
    postEliminarPagoCancelado(payload){
        return axios.post('/cobranza-v2/deletePagosCancelados', payload)
    },
    postEditarMonto(formData){
        return axios.post('/cobranza-v2/updateMonto', formData)
    },
    getRazones(){
        return axios.get('/cobranza-v2/getRazonesCambioMontoCargo')
    },
    getRazonesAbono(){
        return axios.get('/cobranza-v2/getRazonesCambioMontoAbono')
    },
    getTransladarSaldos(params){
        return axios.get('/cobranza-v2/trasladarSaldoAFavor', {params})
    },
    // CONCILIACIÓN 
    getFileConciliacion(params){
        return axios.get('/api/v1/conciliacion/banamex/getFilesPorPersona', {params})
    },
    getInfoConciliacion(params){
        return axios.get('/api/v1/conciliacion/banamex/filtrarPorPersona', {params})
    },

    getServicioOpcionalaObligatorio(params){
        return axios.get('/api/v1/cobranza/ServicioOpcionalaObligatorio', {params})
    },

    getSaldoFavor(params){
        return axios.get('/cobranza-v2/getSaldoAFavor', {params})
    },

    getSaldoFavorTransladar(params){
        return axios.get('/cobranza-v2/getSaldoAFavor', {params})
    },
}